import React from 'react'
import { Route } from 'react-router-dom'
import Doc from './Doc'
import Map from 'es6-map'

// eslint-disable-next-line import/no-webpack-loader-syntax
const webpackRequireContext = require.context(
  '!markdown-with-front-matter!./docs',
  false,
  /\.md$/
)

const getDocs = () => {
  return webpackRequireContext.keys().reduce((memo, fileName) => {
    const path = fileName.match(/\.\/([^\.]+)\.*/)[1]
    const file = webpackRequireContext(fileName)
    return memo.set(path, file)
  }, new Map())
}

export const docs = getDocs()

const getDoc = ({ __content, ...meta }) => props => {
  return <Doc {...props} html={__content} meta={meta} />
}

const getRoutes = () => {
  return [...docs.keys()].map(path => (
    <Route key={path} path={`/${path}`} component={getDoc(docs.get(path))} />
  ))
}

export const routes = getRoutes()



// WEBPACK FOOTER //
// ./src/config.js